import { render, staticRenderFns } from "./BoardMain.vue?vue&type=template&id=6b4d3f0a&scoped=true"
import script from "./BoardMain.ts?vue&type=script&lang=ts&external"
export * from "./BoardMain.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardMain.vue?vue&type=style&index=0&id=6b4d3f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d3f0a",
  null
  
)

export default component.exports